import React from "react";
import { Routes, Route } from "react-router-dom";
import PasswordChange from "../components/Layouts/PasswordChange";

const MainRoutes = () => {
  return (
    <Routes>
      <Route path="/passwordChange" element={<PasswordChange />} />
      {/* 다른 내부 페이지들 */}
    </Routes>
  );
};

export default MainRoutes;
